// extracted by mini-css-extract-plugin
export var errorIcon = "_m2-1";
export var nameLogo = "_m2-0";